<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    items?: {
      title: string
      description?: string
      icon?: string
    }[]
  }>(),
  {
    title: 'Kenapa Integrasi API Lewat KiriminAja?',
    items: () => [
      {
        title: 'Dokumentasi Lengkap',
        description: 'Mudah dipahami oleh developer',
        icon: 'material-symbols:fact-check-outline'
      },
      {
        title: 'Uptime 99,9%',
        description: 'Performa stabil meskipun volume pengiriman besar',
        icon: 'material-symbols:speed-outline'
      },
      {
        title: 'Multi Ekspedisi API',
        description:
          'Satu integrasi untuk AnterAja dan banyak ekspedisi lainnya',
        icon: 'material-symbols:widgets-outline'
      }
    ]
  }
)
</script>

<template>
  <UiSectionWrapper
    :title="title"
    hero-image="/images/integration-api-banner-3.webp"
    :items="items"
    class="py-12"
    :with-action="false"
  />
</template>
